import {sendPostRequest, sendPatchRequest, sendDeleteRequest, sendGetRequest, sendPutRequest} from "@/helper/requests";
import guard from "@/urls/roles/guard";
import {executeRequest} from "@/store/utils";
import {getUserToken} from "@/helper";

const state = {
    orders: {
        currentUrl: null,
        items: [],
        loading: false,
        count: 0,
        error: null,
        detail: []
    },
    visitors: {
        currentUrl: null,
        items: [],
        loading: false,
        count: 0,
        error: null
    },
    loading: false
}

const getters = {
    getOrdersList: state => state.orders.items,
    getOrdersCount: state => state.orders.count,
    getOrdersCurrentUrl: state => state.orders.currentUrl,
    isLoadingOrders: state => state.orders.loading,
    getOrdersDetail: state => state.orders.detail,
    saveOrdersError: state => state.orders.error,

    getVisitorsList: state => state.visitors.items,
    getVisitorsCount: state => state.visitors.count,
    getVisitorsCurrentUrl: state => state.visitors.currentUrl,
    isLoadingVisitors: state => state.visitors.loading,
    saveVisitorsError: state => state.visitors.error,
    getSupLoad: state => state.loading
}

const actions = {
    loadOrdersList: ({commit, getters}, {url, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) {
            url = guard.GUARD.ORDERS.LIST()
            if (urlAppend) url = urlAppend(url)
        }
        if (!getters.isLoadingOrders){
            commit("SET_LOADING");
            commit("SET_ORDERS_LOADING");
            let headers = {}
            if(window.$cookies.get("guard_hash")){
                headers = {
                    "Content-Type": "application/json",
                    "Authorization": window.$cookies.get("guard_hash")
                }
            }
            sendGetRequest(
                url, (data, url) => {
                    commit("SET_LOADING_END");
                    commit("SET_ORDERS_LIST", data);
                    commit("SET_ORDERS_COUNT", data.length);
                    commit("SET_ORDERS_CURRENT_URL", url);
                    commit("SET_ORDERS_LOADING_END");
                    finalizer(data, url);
                }, (data, url, status) => {
                    commit("SET_LOADING_END");
                    commit("SET_ORDERS_LOADING_END");
                    commit("SAVE_ORDERS_ERROR", data);
                    catcher(data, url, status);
                },
                undefined,
                headers
            )
        }
    },
    loadOrdersDetail: ({commit}, {url, id,gets = null, finalizer=()=>{}, catcher=()=>{}}) => {
        commit("SET_LOADING");
        if (!url) url = guard.GUARD.ORDERS.DETAIL(id, gets)
        sendGetRequest(
            url, (data, url) => {
                commit("SET_LOADING_END");
                commit("SET_ORDERS_DETAIL", data);
                finalizer(data, url);
            }, (data, url) => {
                commit("SET_LOADING_END");
                commit("SAVE_ORDERS_ERROR", data);
                catcher(data, url);
            }
        )
    },

    loadVisitorsList: ({commit, getters}, {url, order_id,  urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
        if (!url) {
            url = guard.GUARD.ORDERS.VISITORS.LIST(order_id)
            if (urlAppend) url = urlAppend(url)
        }
        if (!getters.isLoadingVisitors){
            let headers = {}
            if(window.$cookies.get("guard_hash")){
                headers = {
                    "Content-Type": "application/json",
                    "Authorization": window.$cookies.get("guard_hash")
                }
            }
            commit("SET_VISITORS_LOADING");
            commit("SET_LOADING");
            sendGetRequest(
                url, (data, url) => {
                    commit("SET_LOADING_END");
                    commit("SET_VISITORS_LIST", data);
                    commit("SET_VISITORS_COUNT", data.length);
                    commit("SET_VISITORS_CURRENT_URL", url);
                    commit("SET_VISITORS_LOADING_END");
                    finalizer(data, url);
                }, (data, url) => {
                    commit("SET_LOADING_END");
                    commit("SET_VISITORS_LOADING_END");
                    commit("SAVE_VISITORS", data);
                    catcher(data, url);
                },
                undefined,
                headers
            )
        }
    },
    letInVisitors: ({commit}, {data, id, finalizer=()=>{}, catcher=()=>{}}) => {
        let url =  guard.GUARD.ORDERS.VISITORS.LET_IN(id)
        let headers = {}
        if(window.$cookies.get("guard_hash")){
            headers = {
                "Content-Type": "application/json",
                "Authorization": window.$cookies.get("guard_hash")
            }
        }
        commit("SET_LOADING");
        sendPutRequest(
            url,
            data,
            (data, url) => {
                commit("SET_LOADING_END");
                finalizer(data, url);
            }, (data, url) => {
                commit("SET_LOADING_END");
                commit("SAVE_VISITORS_ERROR", data);
                catcher(data, url);
            },
            headers
        )
    },
    letOutVisitors: ({commit}, {data, id, finalizer=()=>{}, catcher=()=>{}}) => {
        let url =  guard.GUARD.ORDERS.VISITORS.LET_OUT(id)
        let headers = {}
        if(window.$cookies.get("guard_hash")){
            headers = {
                "Content-Type": "application/json",
                "Authorization": window.$cookies.get("guard_hash")
            }
        }
        commit("SET_LOADING");
        sendPutRequest(
            url,
            data,
            (data, url) => {
                commit("SET_LOADING_END");
                finalizer(data, url);
            }, (data, url) => {
                commit("SET_LOADING_END");
                commit("SAVE_VISITORS_ERROR", data);
                catcher(data, url);
            },
            headers
        )
    },
    setLoad: ({commit}) => {
        commit("SET_LOADING");
    }
}

const mutations = {
    SET_ORDERS_LIST: (state, orders) => {
        state.orders.items = orders
    },
    SET_ORDERS_COUNT: (state, value) => {
        state.orders.count = value
    },
    SET_ORDERS_CURRENT_URL: (state, value) => {
        state.orders.currentUrl = value
    },
    SET_ORDERS_LOADING: (state) => {
        state.orders.loading = true
    },
    SET_ORDERS_LOADING_END: (state) => {
        state.orders.loading = false
    },
    SET_ORDERS_DETAIL: (state, value) => {
        state.orders.detail = value
    },
    SAVE_ORDERS_ERROR: (state, error) => {
        state.orders.error = error
    },



    SET_VISITORS_LIST: (state, visitors) => {
        state.visitors.items = visitors
    },
    SET_VISITORS_COUNT: (state, value) => {
        state.visitors.count = value
    },
    SET_VISITORS_CURRENT_URL: (state, value) => {
        state.visitors.currentUrl = value
    },
    SET_VISITORS_LOADING: (state) => {
        state.visitors.loading = true
    },
    SET_VISITORS_LOADING_END: (state) => {
        state.visitors.loading = false
    },
    SAVE_VISITORS_ERROR: (state, error) => {
        state.visitors.error = error
    },
    SET_LOADING: (state) => {
        state.loading = true
    },
    SET_LOADING_END: (state) => {
        state.loading = false
    }
}


export default {
    namespaced: false,
    state,
    mutations,
    actions,
    getters
}
